module.exports = __webpack_public_path__ + "img/aksi.6090d6f5.svg";